import React from 'react';
import { StatusTag } from '../components';
import { getDossierStatusColor } from '../const/statutsDossier';
import { DossierStatus, DossierStatusKeys } from '../types/Dossier';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'contexts/AuthContext';
import { AccessType } from 'types/User';

export default function DossierStatusTag({
  full = false,
  status,
}: {
  status?: DossierStatus;
  full?: boolean;
}) {
  const { t } = useTranslation();
  const { auth } = useAuthContext();
  const isConcessionnaire =
    auth?.user.accessType === AccessType.CONCESSIONNAIRE;

  if (!status) {
    return null;
  }

  // Changement de la clé de statut pour les concessionnaires
  const statusKey =
    isConcessionnaire && DossierStatusKeys[status] === 'ChantierEnCours'
      ? 'ChantierEnCours_concession'
      : DossierStatusKeys[status];

  return (
    <StatusTag
      full={full}
      status={t(`statuts_dossier:${statusKey}`)}
      color={getDossierStatusColor(status)}
      className="!py-1 !-my-0 align-middle"
    />
  );
}
